import { styled } from '@mui/material/styles';
import { Image, Typography, Rating } from 'core/common/ui/ui-kit';

export const WrapperStyled = styled('div')`
  padding: 16px 12px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.secondary};

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    background-color: ${({ theme }) => theme.palette.contentBlockBackground.main};
  }
`;

export const RatingStarsStyled = styled(Rating)`
  margin-bottom: 16px;
  font-size: 20px;
`;

export const MessageStyled = styled(Typography)`
  margin-bottom: 16px;
`;

export const FooterStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const UserNameWrapperStyled = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const UserNameStyled = styled(Typography)`
  margin-bottom: 4px;
`;

export const VerifiedTextStyled = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const BadgeStyled = styled(Image)`
  margin-left: 4px;
`;

export const DateStyled = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;
